/*!

 File: set-entity-search.js
 Author: Ember
 Version: 1.0.3 - [CCS-876] - show as selected on load
 JS Dependencies:
    'helper-on' - helper,
    'triggerEvent' - helper,
    'closest' - polyfill

 CSS Dependencies:

 Description:
    Ajax search results

*/

/*!
 * Serialize all form data into a SearchParams string
 * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
var serialize = function (form) {
	var arr = [];
	Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
        
		if (field.type === 'select-multiple') {
			Array.prototype.slice.call(field.options).forEach(function (option) {
                if (!option.selected) return;
                // THIS IS AUTMATICALLY ADDING SQUARE BRACKETS TO MULTI SELECTS
                //arr.push(encodeURIComponent(field.name + '[]') + '=' + encodeURIComponent(option.value));
                arr.push(encodeURIComponent(field.name + '[]') + '=' + encodeURIComponent(option.value));
			});
			return;
		}
		if (['checkbox', 'radio'].indexOf(field.type) >-1 && !field.checked) return;
		arr.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
	});
	return arr.join('&');
};


var setEntitySearch = {
    init: function (elTarget) {

        // Get URL
        var saveUrl = elTarget.getAttribute('data-update-url');
        var elResults = elTarget.querySelector('.js-entity-search-results');
        var elResultsInner = elTarget.querySelector('.js-entity-search-results-inner');

        var disableChange = false; // Disable change events

        // NEED IE POLYFILL !!!!!
        // Get params from current URL
        var url = new URL(window.location);
        var searchParams = new URLSearchParams(url.search);
        var searchState = {};
        searchParams.forEach(function(value, key) {
            searchState[key] = value;
        });


        // is this a user triggered change or a programattic change?
        var programChange = false;
        
        //console.log(searchState);
        //console.log(url.pathname + '' + url.search);

        // Init history state
        // https://stackoverflow.com/questions/11092736/window-onpopstate-event-state-null
        window.history.pushState (searchState, null, window.location);

        window.addEventListener('popstate', function (event) {
            // pushing the back button should switch the fields and re-run the search
            // but is gonna be a nightmare to set up
            //console.log(event.state);
        });

        // declare an axios request's cancelToken
        var ajaxRequest = null; 
        
        // on Change event
        var changeEvt = function(e){

            var el = e.target;

            // Closest captures self as well a parents
            if (el.classList.contains('js-entity-search-prefill-check')){ 
                if(el.checked){
                    setPrefilledFields();
                }else{
                    setPrefilledFields(true);
                }
                return;
            }

            // Button clicked
            e.preventDefault();

            // We assume that a form change means that 'jobs for you' is no longer correct so can uncheck that box
            // but only if user has triggered change (not programattic)
            if(!programChange){
                var elJobsForYouCheck = elTarget.querySelector('.js-entity-search-prefill-check');
                if(elJobsForYouCheck){
                    elJobsForYouCheck.checked = false;
                }
            }

            if(saveUrl && !disableChange){
                // partially fade out results while 'thinking'
                elTarget.classList.add('searching');
                elTarget.offsetHeight; // force reflow
                elTarget.classList.add('searching-fade');

                // Build params for AJAX request
                var elForm = elTarget.querySelector('form');
                var params = serializeArray(elForm, true);
                
                // Build params for URL update
                var urlParams = serialize(elForm);

                // Push to history
                history.pushState(searchState, 'Jobs', url.pathname + '?' + urlParams);

                // Default error message
                var errorMessage = 'Sorry, there was a problem with your request.';

                // cancel  previous ajax if exists
                if (ajaxRequest) {
                    ajaxRequest.cancel('Request cancelled'); 
                }

                // create a new token for upcomming ajax (overwrite the previous one)
                ajaxRequest = axios.CancelToken.source(); 
                
                // Set XMLHttpRequest header - required for PHP CI is_ajax_request() to work
                var config = {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    cancelToken: ajaxRequest.token
                }

                // AJAX request
                axios.post(saveUrl, params, config)
                    .then(function (response) {

                        var responseJson = response.data;
                        
                        // Returned Success
                        if(responseJson.status=='success'){

                            elTarget.classList.remove('searching-fade');
                            elTarget.classList.add('fade-out');

                            // count update
                            var elCount = document.querySelector('.js-entity-search-results-count');
                            if(elCount){
                                elCount.classList.add('fade-out');
                            }
        
                            setTimeout(function(){
                                
                                // count update
                                if(elCount){
                                    elCount.innerText = responseJson.entities.length + ' results';
                                    elCount.classList.remove('fade-out');
                                }
                                
                                // clear results
                                elResultsInner.innerHTML = '';

                                // Process data
                                if(responseJson.entities && responseJson.entities.length){

                                    // Create a fragement
                                    var fragment = document.createDocumentFragment();

                                    responseJson.entities.forEach(function (entity) {
                                        if(entity.html && entity.html != ''){
                                            var elDiv = document.createElement('div');
                                            elDiv.innerHTML = entity.html;
                                            fragment.appendChild(elDiv);
                                        }
                                    });

                                    elResultsInner.appendChild(fragment);

                                    // Set truncated block
                                    var elTruncatedBlocks = elResultsInner.querySelectorAll('.js-truncated-block'); // NodeList
                                    if(elTruncatedBlocks && elTruncatedBlocks.length>0){
                                        forEachNode(elTruncatedBlocks, function (i, el) {
                                            setTruncatedBlock.init(el);
                                        });
                                    }

                                }else{
                                    // No results
                                    //console.log('no results');
                                }


                                // Fade in data
                                setTimeout(function(){
                                    elTarget.classList.remove('fade-out');
                                    setTimeout(function(){
                                        elTarget.classList.remove('searching');
                                        // Need to set fields and get data when back button pressed
                                        // history.pushState({pageID: 'about'},'Search','/vacancies/search?test=yo')
                                    },200);  
                                },200);  

                            },200);

                            
                        }

                        // Returned Error
                        if(responseJson.status=='error'){
                             // See if a message was returned
                            if(responseJson.message && responseJson.message.text && responseJson.message.text != ''){
                                errorMessage = responseJson.message.text;
                            }

                            setTimeout(function(){
                                elTarget.classList.remove('fade-out', 'searching-fade');
                                setTimeout(function(){
                                    elTarget.classList.remove('searching');
 
                                    Notify({
                                        text: errorMessage,
                                        status: 'error',
                                        offset: 100
                                    }).showNotify();

                                },200);  
                            },200);
                            
                        }

                    })
                    .catch(function (error) {

                        // We don't want error messages when request is cancelled
                        if(!axios.isCancel(error)){
                            
                            if(error.response){
                                errorMessage  += '<br>' + error.response;
                            }
    
                            setTimeout(function(){
                                elTarget.classList.remove('fade-out', 'searching-fade');
                                setTimeout(function(){
                                    elTarget.classList.remove('searching');
                                     
                                    Notify({
                                        text: errorMessage,
                                        status: 'error',
                                        offset: 100
                                    }).showNotify();
   
                                 },200);  
                            },200);

                        }
                        
                    })

            }

            // reset programattic change flag
            programChange = false;

        }

        // Attach open event
        on('change', elTarget, changeEvt);

        // Custom selects have their own event
        on('customSelectChange', elTarget, changeEvt);

        // Date pickers have their own event
        on('datePickerChange', elTarget, changeEvt);

        var setPrefilledFields = function(clearFields){
            // Stop fields submitting
            disableChange = true;

            var elForm = elTarget.querySelector('form');

            Array.prototype.slice.call(elForm.elements).forEach(function (field) {

                if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1 || field.classList.contains('js-entity-search-prefill-check')) return;

                if (['checkbox', 'radio'].indexOf(field.type) >-1) {
                    if(clearFields){
                        field.checked = false;
                    }else{
                        field.checked = field.classList.contains('js-entity-search-prefill');
                    }
                    
                    return;
                }

                if (field.type === 'select-multiple') {
                    Array.prototype.slice.call(field.options).forEach(function (option) {
                        if(clearFields){
                            option.selected = false;
                        }else{
                            option.selected = option.classList.contains('js-entity-search-prefill');
                        }
                    });
                    // update chosen
                    if(field.classList.contains('js-select')){
                        triggerEvent(field,'chosen:updated');
                    }
                    //
                    return;
                }

            });

            // Allow fields to submit again
            disableChange = false;

            // Run search by triggering a change event on any field
            var elCheck = elForm.querySelector('input[type="checkbox"]');
            programChange = true;
            triggerEvent(elCheck,'change');
        }

        // Set the search fields based on the loaded search params
        var setFields = function(searchParams){

            var urlItems = {};
            searchParams.forEach(function(value, key) {
                // find field
                var selector = key.replace('[]','');
                let elField = document.querySelector('[name="' + selector + '"]');

                if(elField){
                    if(elField.type == 'select' || elField.type == 'select-multiple' ){
                        for (var i = 0; i < elField.options.length; i++) {
                            if(value === elField.options[i].value){
                                elField.options[i].selected = 1;
                            }
                        }
                        // update chosen
                        if(elField.classList.contains('js-select')){
                            triggerEvent(elField,'chosen:updated');
                        }
                    }
                }

            });

        }

        setFields(searchParams);
        
        // pre-select fields button
        var clickEvt = function(e){

            var el = e.target;

            // Closest captures self as well a parents
            if (!el.closest('.js-entity-search-prefill-btn')) return;

            // Button clicked
            e.preventDefault();

            setPrefilledFields();

        }

        on('click', elTarget, clickEvt);
      
        
    },
    destroy: function () {

    }
};
